import Button from '@mui/material/Button'
// Pass button to any legacy imports
export default Button
